import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import type { FehAddressCheckRequest } from './feh-address-check.interface';
import { UtilApiActions } from '../api/util.ngrx-wrapper';
import { fehServicesStoreSelectorKey } from '../feh-services.state';
import { fehAddressCheckKey } from './feh-address-check.reducer';

@Injectable()
export class FehAddressCheckService {
  private readonly store = inject(Store);
  public addressCheckState = this.store.selectSignal(
    (state) => state[fehServicesStoreSelectorKey][fehAddressCheckKey]
  );

  public checkAddress(address: FehAddressCheckRequest): void {
    this.store.dispatch(
      UtilApiActions.getAddressCheck.requestAction({ payload: address })
    );
  }
}
